import authApi from '@/api/auth';
import {
    MACHINE_STATUS,
    MACHINE_LIST_STYLE,
    MACHINE_STATUS_TEXT,
    MACHINE_STATUS_COLOR,
    MACHINE_STATUS_DOT_COLOR,
    MACHINE_STATUS_STYLE_TEXT,
    MACHINE_STATUS_ICON
} from '@/constant/rental';
import { ACTION } from '@/constant/baseConstant';
import { GPURENTAL_STATUS_CODE } from "@/constant/config";
//import { ROUTE_URL } from "@/constant/route";
export default {
    install(Vue) {
        // Vue.prototype.$banners = [
        //     { imageUrl: "/promotion/1133x200_Goodbye Summer.jpg", id:  1, routeUrl: ROUTE_URL.RECHARGE }
        // ];
        // Vue.prototype.$bannersMobile = [
        //     { imageUrl: "/promotion/mobile/1500x500_Goodbye Summer_en.jpg", id:  1, routeUrl: ROUTE_URL.RECHARGE }
        // ];
        Vue.prototype.$lang = {
            message: {
                error404: 'Oops! 404 - Not Found',
                error500: 'Oops! 500 - Internal Server Error',
            },
            dialog: {
                errorOpps: 'Oops! something went wrong !',
                connectionFailed: 'Connection failed',
                success: 'Success !',
                loginFailed: 'Login failed ...',
                sendEmailFailed: 'Send email failed ...',
                forgotPasswordFailed: 'Password recovery failed ...',
                registerSuccess: 'Happy rendering !',
                registerFailed: 'Register failed ...',
                changePasswordFailed: 'Change password failed ...',
                loadMachineListFailed: 'Failed to load the list of machines...',
                preBootMachineFailed: 'Failed pre-boot machines...',
                changeServicePackageFailed: 'Failed to change service package...',
                requestNotificationMachineFailed: 'Failed to sent request...',
                loadServicePackListFailed: 'Load list of service packages failed...',
                createMachineFailed: 'Machine creation failed...',
                bootMachineFailed: 'Boot machine failed...',
                cloneImageFailed: 'Clone image failed...',
                shutdownMachineFailed: 'Shutdown machine failed...',
                resetMachineFailed: 'Reset failed...',
                cancelMachineFailed: 'Cancel machine failed...',
                removeMachineFailed: 'Remove machine failed...',
                loadListBillingFailed: 'Billing history loading failed...',
                loadListTransactionFailed: 'Transaction history loading failed...',
                PaymentFailed: 'Payment failed...',
                getProfileFailed: 'Get profile information failed...',
                renameFailed: 'Rename machine failed...',
                removeMachineConfirm: 'Are you sure want to remove system image {0} ?',
                shutdownMachineConfirm: 'Do you want to shutdown system image {0} ?',
                resetMachineConfirm: 'Do you want to reset system image {0} ?',
                cancelMachineConfirm: 'Do you want to cancel boot system image {0} ?',
                bootMachineTitle: 'Boot confirm...',
                bootMachineConfirm: 'Do you want boot system image {0} ?',
                cloneMachineTitle: 'Clone confirm...',
                cloneMachineConfirm: 'Do you want clone system image {0} ?',
                shutdownMachineTitle: 'Shutdown confirm...',
                resetMachineTitle: 'Reset confirm...',
                cancelMachineTitle: 'Cancel confirm...',
                removeMachineTitle: 'Remove confirm...',
                requestImageFailed: 'Send request failed...',
                logoutTitle: 'Logout !',
                logoutConfirm: 'Are you sure want to logout your account ?',
            },
            notification: {
                fixedRentalCreateSuceessTitle: 'Creating... !',
                fixedRentalCreateSuccessContent: 'Machine has been successfully fixed rent',
                createSuceessTitle: 'Creating... !',
                createSuccessContent: 'Machine <span style="color: #42A5F5;"> {0}</span> is being created...</span>',
                bootSuceessTitle: 'Booting... !',
                bootSuccessContent: 'Machine <span style="color: #42A5F5;"> {0}</span> is booting...</span>',
                changeServicePackageSuceessTitle: 'Changed !',
                changeServicePackageContent: 'Machine <span style="color: #42A5F5;"> {0}</span> changed service package successfully...</span>',
                cloneSuceessTitle: 'Duplicating... !',
                cloneSuccessContent: 'Machine <span style="color: #42A5F5;"> {0}</span> is duplicating...</span>',
                shutdownSuceessTitle: 'Shutdown success !',
                shutdownSuccessContent: 'Machine <span style="color: #42A5F5;"> {0}</span> has been shutdown successfully</span>',
                resetSuceessTitle: 'Reset... !',
                resetSuccessContent: 'Machine <span style="color: #42A5F5;"> {0}</span>  is being reset...</span>',
                removeSuceessTitle: 'Remove success !',
                removeSuccessContent: 'Machine <span style="color: #42A5F5;"> {0}</span> has been remove successfully</span>',
                cancelSuceessTitle: 'Cancel success !',
                cancelSuccessContent: 'Machine <span style="color: #42A5F5;"> {0}</span> has been cancel boot successfully</span>',
                renameSuceessTitle: 'Rename success !',
                renameSuccessContent: 'Machine <span style="color: #42A5F5;"> {0}</span> has been renamed successfully to <span style="color: #42A5F5;"> {1}</span>',
            },
            common: {
                appCode: 'gpuRental',
            },
            login: {
                slogan: 'High-Performance GPU Computer Rental Service',
                username: 'Email or username...',
                password: 'Type your password...',
                rememberPassword: 'Remember me',
                forgotPassword: 'Forgotten account?',
                login: 'LOGIN',
                description: `You don't have an account?`,
                register: 'Register',
                validationRequiredUsername: 'Username must not be blank',
                validationRequiredPassword: 'Password must not be blank',
                validationRequiredRecaptcha: 'Please confirm you are not a robot',
            },
            forgotPassword: {
                slogan: 'Enter email to reset your account',
                email: 'Your email address...',
                sendRequest: 'SEND REQUEST',
                cancel: 'Cancel',
                validationRequiredEmail: 'Enter the email you have registered',
                validationTypeEmail: `What you look like doesn't seem to be an email address`,
            },
            register: {
                slogan: 'Enter your information to create an account',
                validationRequiredUsername: `Don't leave your username blank !`,
                validationMinUsername: 'Your username is too short. Try something longer',
                validationMaxUsername: 'Are you sure this is your username? It is too long to memorize',
                validationSpecialCharUsername: `Sorry! We don't accept special characters`,
                validationRequiredEmail: 'We will serve you better with your email. Fill it up !',
                validationTypeEmail: 'It seems to be not an email address!',
                validationMaxEmail: 'Are you sure this is your email? It is too long to memorize',
                validationrequiredPhone: 'Phone numbers are required for us to assist you when needed',
                validationTypePhone: 'Are you sure you are entering the phone number',
                validationMinPhone: 'The phone number you entered is too short',
                validationMaxPhone: 'It seems that this is a natural number, not a phone number',
                validationRequiredRegion: 'Please select your country',
                validationRequiredPassword: `Don't leave your password blank !`,
                validationTypePassword: 'Passwords include numerals, capital letters, !, @, #, $, %, ^, &, or *',
                passwordAtLeastUppercaseChar: 'Password must at least one uppercase letter',
                passwordAtLeastLowercaseChar: 'Password must at least one lowercase letter',
                passwordAtLeastNumber: 'Password must at least one number',
                passwordAtLeastSpecialChar: 'Password must at least one special character in !, @, #, $, %, ^, &, *',
                passwordAtNoSpace: 'Password must not contain spaces',
                validationMinPassword: 'Password must be 6-50 characters. Try another password.',
                validationMaxPassword: 'Password must be 6-50 characters. Try another password.',
                validationConfirmPasswordMatch: 'The password and confirm password do not match',
                validationTerms: `You can't register without accepting our terms of services`,
            },
            changePassword: {
                title: 'Change password...',
                oldPassword: 'Your current password...',
                newPassword: 'Your new password...',
                confirmPassword: 'Re-type your new password again...',
                change: 'CHANGE',
                validationRequiredPassword: `Don't leave your password blank !`,                
                passwordAtLeastUppercaseChar: 'Password must at least one uppercase letter',
                passwordAtLeastLowercaseChar: 'Password must at least one lowercase letter',
                passwordAtLeastNumber: 'Password must at least one number',
                passwordAtLeastSpecialChar: 'Password must at least one special character in !, @, #, $, %, ^, &, *',
                passwordAtNoSpace: 'Password must not contain spaces',
                validationMinPassword: 'Password must be 6-50 characters. Try another password.',
                validationMaxPassword: 'Password must be 6-50 characters. Try another password.',
                validationConfirmPasswordMatch: 'The password and confirm password do not match',
            },
            profile: {
                username: 'Username',
                userCode: 'User code',
                email: 'Email',
                fullName: 'Full name',
                phone: 'Phone',
                address: 'Address',
                birthday: 'Birthday',
                gender: 'Gender',
                region: 'Region',
                dateJoin: 'Date join',
                usernameDescription: 'Your full name...',
                phoneDescription: 'Your phone number...',
                addressDescription: 'Your address...',
                birthdayDescription: 'Your birthday...',
                validationRequiredFullName: `Don't leave your full name blank !`,
                validationMaxFullName: 'Are you sure this is your full name? It is too long',
                validationrequiredPhone: 'Phone numbers are required for us to assist you when needed',
                validationTypePhone: 'Are you sure you are entering the phone number',
                validationMinPhone: 'The phone number you entered is too short',
                validationMaxPhone: 'It seems that this is a natural number, not a phone number',
                validationRequiredAddress: `Don't leave your address !`,
                validationMaxAddress: 'The address is too long',
                validationRequiredRegion: 'Please select your country',
                validationRequiredBirthday: 'Please select your birthday',
                validationRequiredGender: 'Please select your gender',
            },
            toolbar: {
                availableCPU: 'Server ',
                availableGPU: 'Server ',
                home: 'GpuHub',
                remoteFarm: 'Remote farm',
                payment: 'Payment',
                rechargeManagement: 'Recharge management',
                rewards: 'Rewards',
                profile: 'Profile',
                changePassword: 'Change password',
                billingHistory: 'Billing history',
                logout: 'Logout',
            },
            home: {
                create: 'Create new image',
                recharge: 'Balance is not enough !!!',
                rechargeDescription: 'Your balance is currently not sufficient.',
                rechargeDescriptionHaveMachineRunning: 'You have used too much balance in your account. Existing machines will be automatically turned off after 30 minutes',
                rechargeNote: '**Please recharge your account so work is not interrupted. Thank you.',
                createDescription: 'You can install any application you like and use the image as if it was your own computer. Each image is an independent system you can reuse.',
                createNote: '**It takes about 20 minutes to boost a new system and load it up the first time, and 5 minutes the next time',
                servicePackTitle: 'Choose a GPU service pack',
                continue: 'Continue',
                settingsImageTitle: 'Create new system image',
                renameImageTitle: 'Create new name image',
                rename: 'Change name',
                createImage: 'Create image',
                nameImageTitle: 'Give image a name...',
                informationTitle: 'Information:\xa0',
                informationDescription: `A clone without boot usually takes between 10 and 20 minutes. A clone with boot usually takes between 20 and 60 miutes. Note ! This applies for first boot only as this includes preparation phase. All consecutive boots of the image are faster, usually 3-5 minutes.`,
            },
            payment: {
                bankTransfer: 'Bank transfer',
                note: 'Note: ',
                description: 'After receiving the transaction information, we will recharge your point in about 24 working hours..',
                accountName: 'Account name:',
                bankName: 'Bank name:',
                bankBranch: 'Bank branch:',
                swiftCode: 'Swift code:',
                bankAddress: 'Bank address:',
                accountNo: 'Account No:',
                rememberTitle: 'Remember:\xa0',
                rememberDescription: 'Please enter your username in the transfer information.',
                exampleTitle: 'Example: User\xa0',
                exampleDescription: '\xa0recharge account balance',
                billingTab: 'Billing invoices',
                transactionTab: 'Payment history',
                code: 'Billing number',
                machineId: 'Machine ID',
                servicePack: 'Service pack',
                imageName: 'Image name',
                billingCharge: 'Billing charged',
                balance: 'Balance',
                createAt: 'Transaction time',
                startTime: 'Start time',
                endTime: 'End time',
                duration: 'Duration',
                transactionId: 'ID',
                provider: 'Provider',
                ref: 'Transaction ID',
                point: 'Point',
                amount: 'Amount',
                type: 'Type',
                status: 'Status',
                blockPopup: 'Your browser has blocked the popup. To continue payment please turn off the pop-up blocker in settings or accept pop-up on screen',
            },
            requestImage: {
                validationRequiredEmail: 'Enter your email address...',
                validationTypeEmail: 'The email address is incorrect',
                validationMaxEmail: 'Please enter a shorter email address',
                validationRequiredFullName: `Don't leave your full name blank !`,
                validationMaxFullName: 'Are you sure this is your full name? It is too long',
                validationrequiredPhone: 'Please make sure the phone number is right so we can easily contact you',
                validationTypePhone: 'Are you sure you are entering the phone number',
                validationMinPhone: 'The phone number you entered is too short',
                validationMaxPhone: 'It seems that this is a natural number, not a phone number',
            }
        };

        Vue.prototype.$CommonParameter = {
            url: {
                gpuhubSyncInternational_win: {
                    value: 'https://irenderpublic.s3.amazonaws.com/release/GpuHub+Sync/setup/1001/GpuHub+Sync-setup.exe'
                },
                gpuhubSyncInternational_mac: {
                    value: 'https://irenderpublic.s3.amazonaws.com/release/GpuHub+Sync/setup/1001/GpuHubSync_macos.dmg'
                },
                gpuhubSyncInternational_linux: {
                    value: 'https://irenderpublic.s3.amazonaws.com/release/GpuHub+Sync/setup/1001/GpuHub_Sync.zip'
                },
                gpuhubSyncVietnam_win: {
                    value: 'https://irenderpublic.s3.amazonaws.com/release/GpuHub+Sync+VN/setup/1001/GpuHub+Sync+VN-setup.exe'
                },
                gpuhubSyncVietnam_mac: {
                    value: 'https://irenderpublic.s3.amazonaws.com/release/GpuHub+Sync+VN/setup/1001/GpuHubSyncVN_macos.dmg'
                },
                gpuhubSyncVietnam_linux: {
                    value: 'https://irenderpublic.s3.amazonaws.com/release/GpuHub+Sync+VN/setup/1001/GpuHub_Sync_VN.zip'
                },
            },
            support: {
                zalo: [],
                skype: [],
                whatsapp: [],
            },
            stateImage: [],
            stateRange: {
                bad: 0,
                normal: 0,
            },
            appMobile: {
                android: {
                    value: 'https://play.google.com/store/apps/details?id=com.irender.gpuhub'
                }
            },
            rating: [
                [],
                [],
                [],
                [],
                [],
            ],
            reportIssues: []
        };

        Vue.prototype.$getParameterCommon = function () {
            authApi.getParameterByType('gpuHubWebApp_common')
                .then((res) => {
                    try {
                        switch (res.errorCode) {
                            case GPURENTAL_STATUS_CODE.GetParameter_Success:
                                res.data.forEach(element => {
                                    let objectParameter = {
                                        id: element.id,
                                        name: element.name,
                                        value: element.value,
                                        description: element.description,
                                        info: element.info,
                                        orderNo: element.orderNo,
                                        status: element.status
                                    }
                                    if (element.code === 'url') {
                                        this.$set(Vue.prototype.$CommonParameter.url, element.name, objectParameter);
                                    }
                                    if (element.code === 'appMobile') {
                                        this.$set(Vue.prototype.$CommonParameter.appMobile, element.name, objectParameter);
                                    }
                                    if (element.code === 'report_issues') {
                                        Vue.prototype.$CommonParameter.reportIssues.push(objectParameter);
                                    }
                                    if (element.code === 'rating') {
                                        Vue.prototype.$CommonParameter.rating[element.name - 1].push(objectParameter);
                                    }
                                    if (element.code === 'gpuhubSupport') {
                                        if (element.status !== "1") {
                                            Vue.prototype.$CommonParameter.support[element.info].push(objectParameter);
                                        }
                                    }
                                    if (element.code === 'stateImage') {
                                        Vue.prototype.$CommonParameter.stateImage.push(objectParameter);
                                    }
                                    if (element.code === 'stateRange') {
                                        Vue.prototype.$CommonParameter.stateRange[element.name] = parseFloat(objectParameter.value);
                                    }
                                });
                                break;
                            default:
                                break;
                        }
                    } catch (error) {
                        console.error(error)
                    }
                })
                .catch(error => {
                    console.error(error)
                });
        };

        Vue.prototype.$machineStatus = MACHINE_STATUS;
        Vue.prototype.$machineListStyle = MACHINE_LIST_STYLE;
        Vue.prototype.$machineStatusText = MACHINE_STATUS_TEXT;
        Vue.prototype.$machineStatusColor = MACHINE_STATUS_COLOR;
        Vue.prototype.$machineStatusDotColor = MACHINE_STATUS_DOT_COLOR;
        Vue.prototype.$machineStatusStyleText = MACHINE_STATUS_STYLE_TEXT;
        Vue.prototype.$machineStatusIcon = MACHINE_STATUS_ICON;
        Vue.prototype.$action = ACTION;
        Vue.prototype.$exportInvoiceDocsLink = 'https://docs.gpuhub.net/vietnamese/export-vat-invoice/';
    }
}